// extracted by mini-css-extract-plugin
export default {"item":"AuthItem_item__tIADA"};